// extracted by mini-css-extract-plugin
export default {"recruit-header":"recruit_recruit-header__Oqijw","recruit-body":"recruit_recruit-body__cn2PX"};